import { useEffect, useState } from "react";
import { Toast } from 'antd-mobile'
import CustomScroll from '@src/component/customScroll'
import { getVehicleList } from '@src/service/applyFormSubService'
import { isEmpty } from "@src/util";
import './index.scss'
type VehicleSelector = {
  visible: boolean
  onConfirm: (obj: any) => void
  onClose: () => void
  modelId?: string
  isCfKccChange?: (value: '1' | '0') => void
}
export default function (props: VehicleSelector) {
  const [vehicleList, setVehicleList] = useState<Array<any>>([])
  const [vehicleList1, setVehicleList1] = useState<Array<any>>([])
  const [show, setShow] = useState<boolean>(true)
  const [configuration, setConfiguration] = useState<any>({})
  const [color, setColor] = useState<number>()
  const [config, setConfig] = useState<number>()
  useEffect(() => {
    if (props.modelId && vehicleList.length) {
      try {
        const isCfKcc = vehicleList.find(res => {
          return res.colorAndConfigVos.find((ys: any) => {
            return ys.configVos.find((pz: any) => {
              return pz.id == props.modelId
            })
          })
        })
        props.isCfKccChange && props.isCfKccChange(isCfKcc.isCfKcc)
      } catch (err) {
        console.log(err)
      }

    }
  }, [props.modelId, vehicleList])
  useEffect(() => {
    setShow(true)
    setConfiguration({})
    setColor(undefined)
    setConfig(undefined)
    props.visible && setVehicleList1(vehicleList)
  }, [props.visible])
  useEffect(() => {
    getVehicleList().then(res => {
      setVehicleList(res)
      setVehicleList1(res)
    }).catch(err => {
      Toast.show(err?.errmsg || '获取车型失败')
    })
  }, [])

  // const suBmit = () => {
  //   if (isEmpty(color)) {
  //     Toast.show('请选择颜色')
  //     return
  //   }
  //   if (isEmpty(config)) {
  //     Toast.show('请选择配置')
  //     return
  //   }
  //   props.isCfKccChange && props.isCfKccChange(configuration.isCfKcc)
  //   props.onConfirm(configuration.colorAndConfigVos[color!].configVos[config!]);
  // }
  const suBmit = () => {
    if (typeof color !== 'number') {
      Toast.show('请选择颜色')
      return
    }
    if (typeof config !== 'number') {
      Toast.show('请选择配置')
      return
    }
    props.isCfKccChange && props.isCfKccChange(configuration.isCfKcc)
    props.onConfirm(configuration.colorAndConfigVos[color].configVos[config])
  }
  /**
   * 处理筛选
   */
  const seek = (e: any) => {
    const name = e.target.value;
    const newarr = name ? vehicleList.filter((item: any) => item.vehicleTypeName.includes(name)) : vehicleList
    setVehicleList1(newarr)
  }

  if (props.visible) {
    return <div className="VehicleSelector">
      <div className='box'>
        <div className='page bottomFit'>
          <div className='header'>
            {show ?
              <input type="text" placeholder="请输入搜索内容" className="form-control" onChange={(e) => seek(e)} />
              : <span></span>
            }
            <div onClick={props.onClose} >取消</div>
          </div>
          <CustomScroll>
            {show ? <div className="veList">
              {vehicleList1.map((res, index) => <div key={index} onClick={() => {
                setConfiguration(res)
                setShow(false)
              }} className="ve-item">{res.vehicleTypeName}</div>)}
            </div> : <div className="configuration">
              <div className="title">车型：<span>{configuration.vehicleTypeName}</span></div>
              <div className="title">颜色：</div>
              <div className="model-box">
                {(configuration?.colorAndConfigVos || []).map((res: any, index: number) => <div onClick={() => { setColor(index); setConfig(undefined) }} className={`item ${color == index ? 'active' : ''}`} key={index}>{res.colorName}</div>)}
              </div>
              {(color || color === 0) && <><div className="title">配置：</div>
                <div className="model-box">
                  {(configuration?.colorAndConfigVos[color]?.configVos || []).map((res: any, index: number) => <div onClick={() => { setConfig(index) }} className={`item ${config == index ? 'active' : ''}`} key={index}>{res.configName}</div>)}
                </div></>}
            </div>}
          </CustomScroll>
          {!show && <div className='button-them' onClick={suBmit}>确定</div>}
        </div>
      </div>
    </div>
  }
  return null
}